import type { TFunction } from 'i18next'

export type DashboardPrimaryNavItem = {
  id: string
  to: string
  label: (t: TFunction) => string
  isActive: (pathname: string, hash: string) => boolean
}

export function getDashboardPrimaryNavItems(): DashboardPrimaryNavItem[] {
  const items: DashboardPrimaryNavItem[] = [
    {
      id: 'dashboard',
      to: '/dashboard',
      label: () => 'Dashboard',
      isActive: (pathname) => pathname === '/dashboard',
    },
    {
      id: 'delivered-fleet',
      to: '/delivered-fleet',
      label: () => 'Delivered Fleet',
      isActive: (pathname) => pathname === '/delivered-fleet',
    },
    {
      id: 'systems',
      to: '/workspace',
      label: () => 'Systems',
      isActive: (pathname) => pathname === '/workspace' || pathname === '/systems',
    },
  ]
  items.push(
    {
      id: 'contacts',
      to: '/contacts',
      label: (t) => t('nav.contacts'),
      isActive: (pathname) => pathname === '/contacts',
    },
    {
      id: 'risk-assessment',
      to: '/risk-assessment',
      label: () => 'Risk Assessment',
      isActive: (pathname) => pathname === '/risk-assessment',
    },
    {
      id: 'nms-configurations',
      to: '/nms-configurations',
      label: (t) => t('nav.nmsConfigurations'),
      isActive: (pathname) => pathname === '/nms-configurations',
    },
  )
  return items
}

export const DASHBOARD_NAV_WORKSPACE_IDS = ['dashboard', 'delivered-fleet'] as const
export const DASHBOARD_NAV_LIBRARY_IDS = ['systems', 'contacts', 'risk-assessment', 'nms-configurations'] as const

export function dashboardNavPillClass(active: boolean): string {
  return `text-[13px] font-medium px-2.5 py-1.5 rounded-md transition-colors whitespace-nowrap ${
    active
      ? 'text-slate-900 dark:text-white bg-slate-200/80 dark:bg-slate-700/70'
      : 'text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-slate-100/90 dark:hover:bg-slate-800/60'
  }`
}

export function isToolsNavActive(pathname: string): boolean {
  if (pathname.startsWith('/pentest-history') || pathname === '/pentest-releases') return true
  if (pathname === '/audit-logs' || pathname === '/license-management') return true
  if (pathname.startsWith('/admin/')) return true
  return false
}

export function isSecurityNavActive(pathname: string): boolean {
  return pathname === '/moc' || pathname === '/firewall'
}
